import { render, staticRenderFns } from "./AuthorizationLayout.vue?vue&type=template&id=71ba5996"
import script from "./AuthorizationLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports